import { render, staticRenderFns } from "./demographic-forms-status-badge.vue?vue&type=template&id=0278c282&"
import script from "./demographic-forms-status-badge.vue?vue&type=script&lang=ts&"
export * from "./demographic-forms-status-badge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports